import { Component, Input } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { Router } from '@angular/router';
import * as dayjs from 'dayjs';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';
import { FilePage } from 'src/app/pop-overs/files/file/file.page';
import { DetailsPage as ClientDetailsPage } from '../../clients/details/details.page';
import { DetailsPage as CompanyDetailsPage } from '../../companies/details/details.page';
import { DetailsPage as EmailDetailsPage } from '../../secure-email/details/details.page';
import { DetailsPage as ProjectDetailsPage } from 'src/app/projects/details/details.page';
import { DetailsPage as TaskDetailsPage } from 'src/app/tasks/details/details.page';
import { DetailsComponent as TeamMemberDetailsPage } from 'src/app/components/team-members/details/details.component';

@Component({
  selector: 'app-home-detail-modal',
  templateUrl: './home-detail-modal.component.html',
  styleUrls: ['./home-detail-modal.component.scss'],
})
export class HomeDetailModalComponent {

  @Input() title = 'Details';
  @Input() viewType: 'tasks' | 'missing_info' | 'payments' | 'signatures' | 'uploads' | 'placeholder' = 'placeholder';
  @Input() ownerView: 'all' | 'mine' = 'all';
  @Input() teamMemberGuid = '';
  @Input() urlMod = '';
  @Input() uploadViewFilter: 'all' | 'client' = 'client';
  // Scopes the 'uploads' viewType to a folder's subtree instead of the whole firm - '0' means
  // firm-wide, matching the file explorer's own {guid} route convention.
  @Input() folderGuid = '0';
  tasks: any[] = [];
  items: any[] = [];
  @Input() hours = 48;
  @Input() placeholderIcon = 'fa-solid fa-circle-info';
  @Input() placeholderMessage = 'Detailed view coming soon.';
  companies = [];
  clients = [];
  current_start_date = new Date();
  current_end_date = new Date();

  all_uploads: any[] = [];
  upload_view: 'all' | 'team' | 'client' = 'client';

  loading_items = false;

  readonly hour_options: { hours: number; label: string }[] = [
    { hours: 1, label: 'Last Hour' },
    { hours: 8, label: 'Last 8 Hours' },
    { hours: 24, label: 'Last Day' },
    { hours: 48, label: 'Last 2 Days' },
    { hours: 72, label: 'Last 3 Days' },
    { hours: 168, label: 'Last 7 Days' },
    { hours: 720, label: 'Last Month' }
  ];

  constructor(private modalController: ModalController, private apiService: ApiService, private router: Router, public globalService: GlobalService, private popoverController: PopoverController) {

   }

   ngOnInit() {
    if (this.viewType === 'uploads') this.upload_view = this.uploadViewFilter;
    this.OnHoursChange();
   }

  dismiss() {
    this.modalController.dismiss({ hours: this.hours, ownerView: this.ownerView, uploadViewFilter: this.upload_view });
  }

  private BuildSinceDate(hours: number): string {
    return dayjs().subtract(hours, 'hour').toISOString();
  }

  private BuildRangeParams(hours: number, start_param: string, end_param: string): string {
    return `${start_param}=${this.BuildSinceDate(hours)}&${end_param}=${dayjs().toISOString()}`;
  }

  private BuildOwnerParam(): string {
    return this.ownerView === 'mine' && this.teamMemberGuid ? `&team_member=${encodeURIComponent(this.teamMemberGuid)}` : '';
  }

  GetMissingInfoUrlMod(): string {
    return `${this.urlMod}${this.BuildOwnerParam()}`;
  }

  ShowOwnerViewToggle(): boolean {
    return this.viewType === 'tasks' || this.viewType === 'missing_info' || this.viewType === 'signatures';
  }

  OnOwnerViewChange(view: 'all' | 'mine') {
    if (this.ownerView === view) return;
    this.ownerView = view;
    this.OnHoursChange();
  }

  async OnHoursChange() {
    this.current_start_date = dayjs().subtract(this.hours, 'hour').toDate();
    this.current_end_date = new Date();
    console.log("111111");
    console.log("HOURS< ", this.hours);
    console.log(this.current_start_date.toISOString());
    console.log(this.current_end_date.toISOString());
    if(this.viewType === 'uploads'){
    if(this.clients.length === 0) await this.GetClients();
    if(this.companies.length === 0) await this.GetCompanies();
    }
    if (this.viewType === 'missing_info') {
      return;
    }
    this.loading_items = true;
    if (this.viewType === 'payments') {
      const data: any = await this.apiService.get(`payments?${this.BuildRangeParams(this.hours, 'start_date', 'end_date')}`);
      this.items = data.success ? (data.data || []) : [];
    } else if (this.viewType === 'signatures') {
      const data: any = await this.apiService.get(`email_signatures?${this.BuildRangeParams(this.hours, 'start_date', 'end_date')}${this.BuildOwnerParam()}`);
      this.items = data.success ? (data.data || []) : [];
    } else if (this.viewType === 'uploads') {
      const data: any = await this.apiService.get(`files/${this.folderGuid}?created_date=${this.BuildSinceDate(this.hours)}`);
      this.all_uploads = data.success ? (data.data || []) : [];
    } else if (this.viewType === 'tasks') {
      const data: any = await this.apiService.get(`tasks/completed?${this.BuildRangeParams(this.hours, 'start_date', 'end_date')}${this.BuildOwnerParam()}`);
      this.tasks = data.success ? (data.data || []) : [];
    }
    if (this.viewType === 'uploads') {
      this.FormatData();
      this.ApplyUploadFilter();
    }
    else if (this.viewType == 'signatures') {
      this.FormatData();
    }
    this.loading_items = false;
  }

  ApplyUploadFilter() {
    if (this.upload_view === 'team') this.items = this.all_uploads.filter(i => i.creator?.[0]?.creator_type == 1);
    else if (this.upload_view === 'client') this.items = this.all_uploads.filter(i => i.creator?.[0]?.creator_type == 2);
    else this.items = [...this.all_uploads];
  }

  async ViewClient(guid: string) {
    if (!guid) return;
    const modal = await this.modalController.create({
      component: ClientDetailsPage,
      cssClass: 'large-modal',
      componentProps: { client: { guid } },
      backdropDismiss: false
    });
    await modal.present();
  }

  async ViewCompany(guid: string) {
    if (!guid) return;
    const modal = await this.modalController.create({
      component: CompanyDetailsPage,
      cssClass: 'large-modal',
      componentProps: { company: { guid } },
      backdropDismiss: false
    });
    await modal.present();
  }

  async ViewTeamMember(guid: string) {
    if (!guid) return;
    const modal = await this.modalController.create({
      component: TeamMemberDetailsPage,
      cssClass: 'large-modal',
      componentProps: { team_member: { guid } },
      backdropDismiss: false
    });
    await modal.present();
  }

  async ViewDocument(guid: string) {
    if (!guid) return;
    const modal = await this.modalController.create({
      component: EmailDetailsPage,
      cssClass: 'large-modal',
      componentProps: { guid },
      backdropDismiss: false
    });
    await modal.present();
  }

  DownloadFile(item: any) {
    this.apiService.DownloadFile(item);
  }

  DownloadSignatureFile(item: any) {
    if (!item?.file_guid) return;
    this.apiService.DownloadFile({ guid: item.file_guid });
  }

  async presentFilePopover(e, item) {
    e.stopPropagation();
    e.preventDefault();
    const file_guid = item.file_guid || item.guid;
    const popover = await this.popoverController.create({
      component: FilePage,
      componentProps: { file: { guid: file_guid, file_name: item.file_name, is_important: item.is_important, parent_folder_guid: item.parent_folder_guid }, selected_files: [], minimal: true, show_go_to_folder: true },
      event: e,
      animated: true,
      backdropDismiss: true
    });
    popover.onDidDismiss().then((data) => {
      if (data.data == 4) this.apiService.DownloadFile({ guid: file_guid });
      else if (data.data == 8) this.ToggleImportant(item, file_guid);
      else if (data.data == 9) this.ViewFolder(item.parent_folder_guid);
    });
    return await popover.present();
  }

  async ToggleImportant(item: any, file_guid: string) {
    const new_value = !item.is_important;
    const data: any = await this.apiService.put(`files/${file_guid}/important`, { important: new_value });
    if (data.success) {
      item.is_important = new_value;
      this.globalService.presentToastMessage(new_value ? 'Marked as important' : 'Removed from important', true);
    } else {
      this.globalService.presentToastMessage(data.message, false);
    }
  }

  async ViewFolder(parent_folder_guid: string) {
    if (!parent_folder_guid) return;
    await this.modalController.dismiss({ hours: this.hours });
    this.router.navigate(['/file-explorer'], { fragment: parent_folder_guid });
  }

  GetPaymentStatusLabel(status: number): string {
    if (status == 0) return 'Unpaid';
    if (status == 1) return 'Paid';
    return String(status);
  }

  FormatData() {
    if(this.viewType == 'uploads'){
    for (let item of this.all_uploads) {
      if(item.client_guid) item.client_display_name = this.clients.find(c => c.guid === item.client_guid)?.display_name || '';
      if(item.company_guid) item.company_display_name = this.companies.find(c => c.guid === item.company_guid)?.name || '';

      if(item.creator[0].creator_type === 1) { 
        item.display_name = item.creator[0].creator_display_name || "";
        continue;
      }
      else{
        if(item.company_guid) item.display_name = item.company_display_name + " ("+item.creator[0].creator_display_name+")";
        else item.display_name = item.creator[0].creator_display_name || "";
      } 
    }
  }
  else if (this.viewType == 'signatures'){
    for (let item of this.items) {
      if(item.company_display_name) item.display_name = item.company_display_name + " ("+item.linked_display_name+")";
      else if (item.linked_display_name) item.display_name = item.linked_display_name;
      else item.display_name = "";
    }
  }
}

  ViewClientOrTeamMember(item) {
    if(item.creator[0].creator_type === 1) { 
        this.ViewTeamMember(item.creator[0].creator_guid);
      }
      else{
        if(item.company_guid) this.ViewCompany(item.company_guid);
        else this.ViewClient(item.client_guid);
      }
  }

  async GetCompanies() {
    let data: any = await this.apiService.get(`companies?quick=1`);
    console.log("Companies Data: ", data);
    if(data.success) {
      this.companies = data.data || [];
    }
  }

  async GetClients() {
    let data: any = await this.apiService.get(`clients?quick=1`);
    if(data.success) {
      this.clients = data.data || [];
    }
  }

  async ViewProject(guid: string) {
    if (!guid) return;
    const modal = await this.modalController.create({
      component: ProjectDetailsPage,
      cssClass: 'large-modal',
      componentProps: { guid: guid },
      backdropDismiss: false
    });
    await modal.present();
  }

  async ViewTask(guid: string) {
    if (!guid) return;
    const modal = await this.modalController.create({
      component: TaskDetailsPage,
      cssClass: 'large-modal',
      componentProps: { guid:  guid  },
      backdropDismiss: false
    });
    await modal.present();
  }

}
